import { render, staticRenderFns } from "./bottomDetil.vue?vue&type=template&id=59ec80a3&scoped=true"
import script from "./bottomDetil.vue?vue&type=script&lang=js"
export * from "./bottomDetil.vue?vue&type=script&lang=js"
import style0 from "./bottomDetil.vue?vue&type=style&index=0&id=59ec80a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec80a3",
  null
  
)

export default component.exports